import React from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { preloadEngineeringPage } from '../routes/engineeringPage';
import styles from './RecruitNavigation.module.css';

export { EngineeringTopCta } from './EngineeringTopCta';

export default function RecruitNavigation() {
  return (
    <nav className={styles.links} aria-label="採用情報">
      <Link
        to="/recruit/engineering"
        onMouseEnter={preloadEngineeringPage}
        onFocus={preloadEngineeringPage}
        onPointerDown={preloadEngineeringPage}
      >
        <span>
          <span className={styles.linkTitle}>プロダクト専門職採用</span>
          <span className={styles.linkDescription}>
            エンジニア・デザイナー・PdMなど
          </span>
        </span>
        <ArrowRight size={18} aria-hidden="true" />
      </Link>
      <a
        href="https://www.wantedly.com/companies/company_5841931"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>
          <span className={styles.linkTitle}>
            スタッフ職・その他（Wantedly）
          </span>
          <span className={styles.linkDescription}>
            公開中の募集をWantedlyでご案内
          </span>
          <span className="sr-only">（新しいタブで開きます）</span>
        </span>
        <ArrowUpRight size={18} aria-hidden="true" />
      </a>
    </nav>
  );
}
